export default __webpack_public_path__ + "static/media/speciality_id_1.ce913f2c.png";